/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_ApproveInputs */

const en_agent_authorization_approve = /** @type {(inputs: Agent_Authorization_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve and continue`)
};

const zh_agent_authorization_approve = /** @type {(inputs: Agent_Authorization_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批准并继续`)
};

/**
* | output |
* | --- |
* | "Approve and continue" |
*
* @param {Agent_Authorization_ApproveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_approve = /** @type {((inputs?: Agent_Authorization_ApproveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_ApproveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_approve(inputs)
	return zh_agent_authorization_approve(inputs)
});
export { agent_authorization_approve as "agent.authorization.approve" }